// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { DEFAULT_NUMBER_ONE, EMPTY_STRING } from '~/utils/constants/common';
import { ScheduleTypeEnum } from '~/utils/enum/common';
import { dataTimeZone, getCurrentDateUTC, getEndTimeOption, getNextTimeOption } from '~/utils/helper/common';
import { IFormSchedule } from '~/utils/interface/schedule';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      startDate: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
      endDate: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
      startTime: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
      endTime: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
      assigneeIds: yup
        .array()
        .min(DEFAULT_NUMBER_ONE, t('common_validate_field_required', { ns: 'common/base' }))
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      businessType: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
      businessId: yup.string().when('businessType', {
        is: (value: string) => value !== ScheduleTypeEnum.EVENT,
        then: (schema) => schema.required(t('common_validate_field_required', { ns: 'common/base' })),
        otherwise: (schema) => schema.optional(),
      }),
      eventName: yup.string().when('businessType', {
        is: (value: string) => value === ScheduleTypeEnum.EVENT,
        then: (schema) => schema.required(t('common_validate_field_required', { ns: 'common/base' })),
        otherwise: (schema) => schema.optional(),
      }),
      note: yup.string().optional(),
      timezone: yup.string().optional(),
      // address: yup.string().optional(),
      // address2: yup.string().optional(),
      // city: yup.string().optional(),
      // state: yup.string().optional(),
      // zipCode: yup.string().optional(),
      // country: yup.string().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormSchedule = {
  startDate: getCurrentDateUTC(),
  endDate: getCurrentDateUTC(),
  startTime: getNextTimeOption(),
  endTime: getEndTimeOption(getNextTimeOption()),
  assigneeIds: [],
  businessType: ScheduleTypeEnum.EVENT,
  // businessType: EMPTY_STRING,
  businessId: EMPTY_STRING,
  eventName: EMPTY_STRING,
  note: EMPTY_STRING,
  timezone: dataTimeZone(),
  // address: EMPTY_STRING,
  // address2: EMPTY_STRING,
  // city: EMPTY_STRING,
  // state: EMPTY_STRING,
  // zipCode: EMPTY_STRING,
  // country: EMPTY_STRING,
};
